import { render, staticRenderFns } from "./fifa-group-schedule-row.vue?vue&type=template&id=03da68d2&scoped=true&"
import script from "./fifa-group-schedule-row.vue?vue&type=script&lang=js&"
export * from "./fifa-group-schedule-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da68d2",
  null
  
)

export default component.exports